import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  IconButton,
  Menu,
  MenuItem,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import "./Header.css";

const Header = () => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <AppBar position="fixed" style={{ zIndex: 1201, background: "#123A8A" }}>
      <Toolbar style={{ justifyContent: "space-between", padding: "0 20px" }}>
        {/* Logo */}
        <img
          src="logo.png"
          alt="Zinguería Techos Logo"
          className="logo"
          style={{ maxHeight: "60px", height: "auto", margin: "5px" }}
        />

        {/* Navegación para pantallas grandes */}
        <Box
          display={{ xs: "none", md: "flex" }}
          justifyContent="center"
          alignItems="center"
        >
          <Button color="inherit" href="#services" style={{ margin: "0 10px" }}>
            Servicios
          </Button>
          <Button color="inherit" href="#products" style={{ margin: "0 10px" }}>
            Productos
          </Button>
          <Button color="inherit" href="#contact" style={{ margin: "0 10px" }}>
            Contacto
          </Button>
        </Box>

        {/* Icono del menú para pantallas pequeñas */}
        <Box display={{ xs: "flex", md: "none" }}>
          <IconButton color="inherit" onClick={handleMenuOpen}>
            <MenuIcon />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
          >
            <MenuItem onClick={handleMenuClose}>
              <Button color="inherit" href="#services">
                Servicios
              </Button>
            </MenuItem>
            <MenuItem onClick={handleMenuClose}>
              <Button color="inherit" href="#products">
                Productos
              </Button>
            </MenuItem>
            <MenuItem onClick={handleMenuClose}>
              <Button color="inherit" href="#contact">
                Contacto
              </Button>
            </MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
